import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SidebarNav from '../homepage/widgets/SidebarNav';
import { useHomepageStore } from '../homepage/store/homepageStore';
import { ROUTES } from '../../core/data/routes';

const AppLayout: React.FC = () => {
  const store = useHomepageStore();
  const user = store.retrieve();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  return (
<div
    className="app-layout"
    style={{
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
    }}
  >       {user && (
    <SidebarNav
      user={user}
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      currentTab={tabIndex}
      onTabChange={(i) => {
        setTabIndex(i);
        navigate(ROUTES.INDEX);

        if (window.innerWidth < 1024) {
          setDrawerOpen(false);
        }
      }}
    />
  )}
<div
      className="app-main"
      style={{
        flex: 1,
        overflow: 'scroll',
        display: 'flex',
        flexDirection: 'column',
      }}
    >        
    <Outlet
        context={{
          drawerOpen,
          setDrawerOpen,
          tabIndex,
          setTabIndex,
        }}
      />
      </div>
    </div>
  );
};

export default AppLayout;